
  export const MUSCLES_RECEIVED = "MUSCLES_RECEIVED";
  export const SET_MUSCLE = "SET_MUSCLE";
  export const CREATE_MUSCLE = "CREATE_MUSCLE";
  export const SET_PROPERTY_MUSCLE = "SET_PROPERTY_MUSCLE";
  